import apiDocuments from '@/api/documents'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  updateDocumentStart: '[update document] Update document start',
  updateDocumentSuccess: '[update document] Update document success',
  updateDocumentFailure: '[update document] Update document failure',

  getDocumentStart: '[update document] Get document start',
  getDocumentSuccess: '[update document] Get document success',
  getDocumentFailure: '[update document] Get document failure',
}

export const actionTypes = {
  updateDocument: '[update document] Update document',
  getDocument: '[update document] Get document',
}

const mutations = {
  [mutationTypes.updateDocumentStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateDocumentSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateDocumentFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getDocumentStart](state) {
    state.data = null
    state.isLoading = true
  },

  [mutationTypes.getDocumentSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getDocumentFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateDocument](context, {athleteId, id, document}) {
    context.commit(mutationTypes.updateDocumentStart)
    return new Promise((resolve) => {
      apiDocuments
        .updateAthleteDocument(athleteId, id, document)
        .then((response) => {
          context.commit(mutationTypes.updateDocumentSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateDocumentFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getDocument](context, {athleteId, id}) {
    context.commit(mutationTypes.getDocumentStart)
    return new Promise((resolve) => {
      apiDocuments
        .getAthleteDocument(athleteId, id)
        .then((response) => {
          context.commit(mutationTypes.getDocumentSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getDocumentFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
